import z from 'zod'

import { ENDPOINT } from '@/config/endpoint'
import { apiFactory, apiOk } from '@/libs/api'

import { PurchaseOrderDto } from '../dto/purchase-order-dto'

export type PurchaseOrderMutation = Pick<
  PurchaseOrderDto,
  'code' | 'date' | 'items' | 'note' | 'total'
> & {
  outletId: string
  sourceId: string
}

export const purchaseOrderApi = {
  list: apiFactory({
    method: 'get',
    url: ENDPOINT.inventory.purchaseOrder.list,
    schema: {
      params: z.custom<{ outletId: string }>(),
      result: apiOk(
        z.object({
          orders: PurchaseOrderDto.array(),
        })
      ),
    },
  }),
  detail: apiFactory({
    method: 'get',
    url: ENDPOINT.inventory.purchaseOrder.detail,
    schema: {
      params: z.custom<{ id: string }>(),
      result: apiOk(PurchaseOrderDto),
    },
  }),
  create: apiFactory({
    method: 'post',
    url: ENDPOINT.inventory.purchaseOrder.create,
    schema: {
      body: z.custom<PurchaseOrderMutation>(),
    },
  }),
}
